export enum MapViewType {
	trend = 'trend',
	absolute = 'absolute',
	baseline = 'baseline',
	previous = 'previous',
}

export enum SortTypes {
	influence = 'influence',
	satisfaction = 'satisfaction',
	priority = 'priority',
}

export interface ISortParams {
	type: SortTypes;
	decreasing?: boolean;
}

export interface ISortChecker {
	serviceName: string;
	isAsc: boolean | undefined;
}

export enum LayoutTypes {
	'list',
	'cards',
	'grid',
	'bench',
	'heatmap',
	'personaHeatmap',
	'aiInsights',
	'mojiMap',
	'comments',
	'actionPlan',
	'mapAndTrend',
}

export enum SatisfactionLevelTypes {
	all = 'all',
	great = 'great',
	good = 'good',
	ok = 'ok',
	poor = 'poor',
	veryPoor = 'very_poor',
}

export enum TrendsTypes {
	all = 'all',
	positive = 'positive',
	neutral = 'neutral',
	negative = 'negative',
}
